import { siteConfig, siteContent } from '../../content/siteContent.js'
import { getLocalizedPath } from '../../lib/routing.js'
import { MagneticButton } from '../fx/MagneticCursor.jsx'

export function DetailPage({ locale, slug }) {
  const copy = siteContent[locale]
  const page = copy.pages[slug] ?? copy.pages.home

  return (
    <main className="detail-page">
      <section className="detail-hero">
        <p className="detail-hero__code">CHICROSS / {slug.toUpperCase()}</p>
        <h1>{page.title}</h1>
        <p>{page.description}</p>
      </section>
      <section className="detail-grid" aria-label={page.title}>
        {page.sections?.map((section) => (
          <article className="detail-card" key={section.title} data-reveal>
            <span>{section.title.split(' · ')[0]}</span>
            <h2>{section.title}</h2>
            <p>{section.body}</p>
            {section.items.length > 0 && (
              <ul>
                {section.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            )}
          </article>
        ))}
      </section>
      <section className="detail-cta" data-scrub>
        <p>{copy.contactIntro}</p>
        <MagneticButton href={`mailto:${siteConfig.contactEmail}`}>{copy.primaryCta}</MagneticButton>
        <a className="text-link" href={getLocalizedPath(locale, 'home')}>
          {copy.nav.home}
        </a>
      </section>
    </main>
  )
}
